import { FC } from "react";
import ReportProblemRoundedIcon from "@mui/icons-material/ReportProblemRounded";
import { Stack, Typography, Box } from "@mui/material";
import { green, red } from "@mui/material/colors";
import { getPercentage } from "@/utils/numeral/getPercentage";

interface AccountUtilizationColumnProps {
  empty?: boolean;
  error?: boolean;
  partial: number;
  total: number;
  colors?: {
    partial: string;
    total: string;
  };
}

export const AccountUtilizationColumn: FC<AccountUtilizationColumnProps> = ({
  empty,
  error,
  partial,
  total,
  colors,
}) => {
  const localColors = colors ?? {
    total: green[100],
    partial: red[500],
  };

  const value = getPercentage(partial, total);
  const invalid = error || empty;

  return (
    <Stack direction="row" alignItems="center">
      <Box
        width={170}
        height={8}
        bgcolor={invalid ? "silver" : localColors?.total}
      >
        {!invalid && (
          <Box
            width={`${value}%`}
            height="100%"
            bgcolor={localColors?.partial}
          />
        )}
      </Box>

      {error ? (
        <ReportProblemRoundedIcon sx={{ color: "#FFCA29" }} fontSize="medium" />
      ) : (
        <Typography
          color={empty ? "text.disabled" : ""}
          variant="body2"
          marginLeft={1}
        >
          {isNaN(value) ? 0 : value.toFixed(1)}%
        </Typography>
      )}
    </Stack>
  );
};
